export default __webpack_public_path__ + "static/media/something-went-wrong.e45ef271.png";